module.exports = __webpack_public_path__ + "img/chongya-2.2e50b96e.png";